import { UnitLoadDeviceManager } from './unitLoadDeviceManager'
import StrUtils from '@/utils/StrUtils'
import * as NumberUtils from '@/utils/NumberUtils'
import { TabError } from '@/utils/class/TabError'
import { sortByMultiField } from '@/utils'
import { syncLclSlaveMasterJob } from '@/api/booking/job'
import { TabBookingAbstract } from '@/components/Cargo/Job/booking/tabs/tabBookingAbstract'
import { batchAddJob, unbindingNew } from '@/api/AirExport/airExportJob'
import { AirExportJob } from '@/class/model/booking/AirExportJob'

export class TabLclUnitLoadDeviceBase extends TabBookingAbstract {
  /**
   * @param {Object} view 视图
   */
  constructor(view) {
    super(view)
    this.$message = this.view.$message
    this.$confirm = this.view.$confirm
    this.$refs = this.view.$refs
    this.$store = this.view.$store
    this.$i18n = this.view.$i18n
    this.$emit = this.view.$emit
    this.$t = this.view.$t
    this.$checkPermission = this.view.$checkPermission

    this.manager = null
  }

  get job() {
    return this.view.job
  }
  set job(job) {
    this.view.job = job
  }

  //  装箱明细
  get unitLoadDeviceUsageColl() {
    return this.view.unitLoadDeviceUsageColl
  }
  set unitLoadDeviceUsageColl(unitLoadDeviceUsageColl) {
    this.view.unitLoadDeviceUsageColl = unitLoadDeviceUsageColl
  }

  async commitProperties() {
    this.refreshUnitLoadDevices()

    //   lclSalve 关联unitLoadDevices的同一usages
    await this.refreshSlaveUsageColl()

    this.refreshDatas()
  }

  // lclSalve 关联unitLoadDevices的同一usages
  refreshSlaveUsageColl() {
    for (const slave of this.job.lclSlaves) {
      slave.unitLoadDeviceUsages = []
    }
    for (const unitLoadDevice of this.job.unitLoadDevices) {
      if (unitLoadDevice.unitLoadDeviceUsage && unitLoadDevice.unitLoadDeviceUsage.length > 0) {
        for (const usage of unitLoadDevice.unitLoadDeviceUsage) {
          const slave = this.job.lclSlaves.find(p => p.uuid === usage.jobUuid)
          if (!slave) {
            continue
          }
          slave.unitLoadDeviceUsages.push(usage)
        }
      }
    }
  }
  /**
   * 刷新箱子
   */
  refreshUnitLoadDevices() {
    const job = this.job
    if (!this.manager || !job) { return }

    if (job.unitLoadDevices && job.unitLoadDevices.length > 0) {
      // 默认选中第一行
      this.view.$nextTick(async() => {
        await this.setGridSelect()
        this.unitLoadDeviceChangeHandler()
      })
    } else {
      this.refreshUsages()

      // 没有箱子的情况下，重置装箱信息，避免装箱grid 数据未重置
      const unitLoadDevice = this.view.selectedUnitLoadDevice
      if (unitLoadDevice) {
        unitLoadDevice.unitLoadDeviceUsage = []
      }
    }
  }
  // 箱子设置 选中行(加载数据后默认选中第一行记录)
  setGridSelect() {
    const nodes = this.view.left.gridOptions.api.getRenderedNodes()
    if (!nodes) {
      return
    }
    // 默认选中第一个
    for (const item of nodes) {
      item.setSelected(true)
      this.view.selectedUnitLoadDevice = item.data
      break
    }
  }

  // 装箱信息 设置 选中行
  setUsageGridSelect(selectedRows) {
    const gridApi = this.view.right.gridApi
    const nodes = gridApi.getRenderedNodes()

    for (const item of nodes) {
      if (selectedRows.findIndex(p => p.jobUuid === item.data.jobUuid) > -1) {
        item.setSelected(true)
      }
    }
  }

  // 箱子grid 选中事件
  unitLoadDeviceChangeHandler(event = null) {
    if (event) {
      this.view.selectedUnitLoadDevice = event.data
    }
    this.refreshUsages()
  }

  /**
   * 刷新用量
   */
  refreshUsages() {
    if (!this.manager) { return }
    const unitLoadDevice = this.view.selectedUnitLoadDevice
    if (unitLoadDevice) {
      this.refreshUnitLoadDeviceUsageColl(unitLoadDevice)
      if (this.unitLoadDeviceUsageColl) {
        let index = 0
        // todo serialNo 与cargo 写法不同 从最初开始编码
        index = 1
        for (const c of this.unitLoadDeviceUsageColl) {
          c.serialNo = index++
        }
        this.view.right.gridOptions.api.refreshCells({ force: true })
      }
      // 排序
      sortByMultiField(this.unitLoadDeviceUsageColl, ['serialNo'], false)
      // 改为 push 避免同一引用 多个unitLoadDevice引用指向同一个
      unitLoadDevice.unitLoadDeviceUsage = []
      for (const usage of this.unitLoadDeviceUsageColl) {
        unitLoadDevice.unitLoadDeviceUsage.push(usage)
      }

      this.view.usagesTotalDesc.txtNum = this.view.$t('Message.Count') + '：' + (this.unitLoadDeviceUsageColl == null ? 0 : this.unitLoadDeviceUsageColl.length)
    } else {
      this.unitLoadDeviceUsageColl = []
      this.view.usagesTotalDesc.txtNum = this.view.$t('Message.Count') + '：0'
    }

    let quantity = 0
    let weight = 0
    let cubage = 0
    for (const usage of this.unitLoadDeviceUsageColl) {
      quantity += usage.quantity
      weight += usage.weight
      cubage += usage.cubage
    }
    this.view.usagesTotalDesc.usageTotalQuantity = String(quantity)
    this.view.usagesTotalDesc.usageTotalWeight = NumberUtils.formatNumber(weight, 3)
    this.view.usagesTotalDesc.usageTotalCubage = NumberUtils.formatNumber(cubage, 3)
  }

  refreshUnitLoadDeviceUsageColl(unitLoadDevice) {
    this.unitLoadDeviceUsageColl = []
    if (!unitLoadDevice || !unitLoadDevice.unitLoadDeviceUsage) { return }
    for (const usage of unitLoadDevice.unitLoadDeviceUsage) {
      if (!StrUtils.isEmpty(usage.unitLoadDeviceUuid) && !StrUtils.isEmpty(usage.jobUuid)) {
        this.unitLoadDeviceUsageColl.push(usage)
      }
    }
  }

  /**
   * 应用各个表格的数据
   */
  refreshDatas() {
    if (!this.job || StrUtils.isEmpty(this.job.uuid)) { return }

    this.manager = new UnitLoadDeviceManager(this.job)
    this.manager.clearRemoveSourceUsages()
    this.refreshSalves()
    this.refreshUnitLoadDevices()
  }

  /**
   * 刷新小票
   */
  refreshSalves() {
    const manager = this.manager
    if (!manager) { return }
    this.view.lclSlaves = manager.getUnboxedSlaves()
    let quantity = 0
    var weight = 0
    let cubage = 0
    for (const slave of this.view.lclSlaves) {
      quantity += this.getItemLeft(slave)
      weight += this.getWeightLeft(slave)
      cubage += this.getCubageLeft(slave)
    }
    this.view.slaveTotalDesc.slaveTotalQuantity = String(quantity)
    this.view.slaveTotalDesc.slaveTotalWeight = NumberUtils.formatNumber(weight, 3)
    this.view.slaveTotalDesc.slaveTotalCubage = NumberUtils.formatNumber(cubage, 3)
  }

  // 加入小票
  addSlaveHandler() {
    if (!this.job) {
      return
    }
    this.view.queryAeLclDialog.visible = true
  }

  slaveAddedHandler(rows) {
    const jobKeys = Array.from(rows, p => p.uuid)

    // batchAddJob 后端实现 1.同步 jobKeys 的小票的 etd,vessel 等；2.重新合计主票中的件毛体以及计费重量; 3.进口刷新小票仓库信息
    batchAddJob(jobKeys, this.job.uuid, this.view.location).then(res => {
      if (res.data && res.data.length > 0) {
        for (const item of rows) {
          item.lclMasterUuid = this.job.uuid
          item.version = item.version + 1
          if (!this.job.lclSlaves) {
            this.job.lclSlaves = []
          }
          this.job.lclSlaves.push(item)
        }
        this.view.lclSlaves = this.job.lclSlaves
        this.refreshSlaveUsageColl()
        this.view.$emit('addSlavedJob', rows)
        this.refreshSalves()
      }
    })
  }

  // 移除小票
  removeSlaveHandler() {
    if (!this.view.selectedSlave.uuid) {
      this.$message.info(this.view.$t('请选择小票记录'))
      return
    }

    this.$confirm(this.view.$t('Message.AreYouSureYouWantToRemoveTheSubBill'), this.view.$t('common.tips.prompt'), {
      confirmButtonText: this.view.$t('common.btn.ok'),
      cancelButtonText: this.view.$t('common.btn.cancel'),
      type: 'warning'
    }).then(() => {
      this.removeSlaveCheckHandler()
    })
  }

  /**
   * 移除小票
   * @returns {Promise<void>}
   */
  async removeSlaveCheckHandler() {
    const slave = this.view.selectedSlave

    await new AirExportJob(slave).getUnitLoadDeviceUsages()

    if (slave.quantityActual !== this.getItemLeft(slave) || slave.weightActual !== this.getWeightLeft(slave) ||
      slave.cubageActual !== this.getCubageLeft(slave)) {
      this.$message.warning(this.view.$t('Message.TheSubBillHasBeenConsolidatedAndCannotBeRemoved'))
      return
    }

    for (const c of slave.unitLoadDeviceUsages) {
      if (c.unitLoadDevice && c.unitLoadDevice.jobUuid && c.unitLoadDevice.jobUuid === this.job.uuid) {
        this.$message.warning(this.view.$t('Message.TheSubBillHasBeenConsolidatedAndCannotBeRemoved'))
        return
      }
    }
    slave.lclMaster = null
    // 使用基本tab 的移除小票方法
    this.detachSelectedHandler(slave)
  }
  detachSelectedHandler(job) {
    let pass = true
    if (job.hasSharedCharge) {
      this.$message.warning('当前小票有分摊费用,不能分离!')
      pass = false
      return
    }
    if (!pass) return
    this.$confirm(this.$t('queryJob.AreRemoveThisSubTicket'), this.$t('Message.Prompt'), {
      confirmButtonText: this.$t('common.btn.ok'),
      cancelButtonText: this.$t('common.btn.cancel'),
      type: 'warning'
    }).then(() => {
      const removedSubJobKeys = []
      const removedSubJobs = []
      const removeMbls = []
      if (job.mbl) {
        removeMbls.push(job.mbl)
      }
      removedSubJobKeys.push(job.uuid)
      removedSubJobs.push(job)
      unbindingNew({ 'lclKeys': removedSubJobKeys, 'mblList': removeMbls, 'masterKey': this.job.uuid, 'location': this.view.location }).then(async res => {
        if (res.data) {
          this.slaveResultHandler(res.data, removedSubJobKeys)
        }
      })
    }).catch(() => { })
  }
  slaveResultHandler(num, jobKeys) {
    if (num > 0) {
      // 更新主票上的 件重尺
      syncLclSlaveMasterJob({ jobUuid: this.job.uuid })

      this.job.lclSlaves = ''
      new AirExportJob(this.job).getLclSlaves().then(data => {
        this.job.lclSlaves = data
        this.view.lclSlaves = this.job.lclSlaves
        this.refreshSlaveUsageColl()
      })
      this.view.$emit('removeJobFromMaster', jobKeys, 'tabLclUnitLoadDevice')
    }
    this.refreshSalves()
    this.$message.success(this.view.$t('Message.RemovedSuccesfully'))
  }

  getItemLeft(input) {
    let quantity = input.quantityActual
    for (const usage of input.unitLoadDeviceUsages) {
      quantity = quantity - usage.quantity
    }
    return Number(quantity)
  }
  getWeightLeft(input) {
    let weight = input.weightActual
    if (isNaN(weight)) {
      weight = 0.0
    }
    for (const usage of input.unitLoadDeviceUsages) {
      let usedWeight = usage.weight
      if (isNaN(usedWeight)) {
        usedWeight = 0.0
      }
      weight = weight - usedWeight
    }
    return Number(weight)
  }
  getCubageLeft(input) {
    let cubage = input.cubageActual
    if (isNaN(cubage)) {
      cubage = 0.0
    }
    for (const usage of input.unitLoadDeviceUsages) {
      let usedCubage = usage.cubage
      if (isNaN(usedCubage)) {
        usedCubage = 0.0
      }
      cubage = cubage - usedCubage
    }
    return Number(cubage)
  }
  // 装箱
  addToUnitLoadDeviceHandler() {
    const slaves = this.view.gridOptions.api.getSelectedRows()

    const unitLoadDevices = this.view.selectedUnitLoadDevice// this.view.left.gridApi.getSelectedRows()
    if (!unitLoadDevices || this.job.unitLoadDevices.length === 0) {
      this.$message.warning('请选中一个箱子')
      return
    }

    if (slaves.length > 0 && slaves[0]) { this.addToUnitLoadDevice(slaves, this.view.selectedUnitLoadDevice) }
  }

  addToUnitLoadDevice(slaves, unitLoadDevice) {
    unitLoadDevice.isDirty = true

    const usages = this.manager.multiLoadUnitLoadDevice(slaves, unitLoadDevice)
    this.refreshSalves()
    this.refreshUsages()
    this.view.gridApi.clearFocusedCell() // 取消选中
    this.view.gridApi.deselectAll()

    // 记录 装箱(装箱会改变 removedUnitLoadDeviceUsages 中的值) 同cargo中的syncActionItems
    this.syncActionItems()
  }

  // 移除装箱
  removeToUnitLoadDeviceHandler() {
    const usages = this.view.right.gridApi.getSelectedRows()
    if (usages.length > 0) {
      this.removeToUnitLoadDevice(usages)
    }
  }

  /**
   * 卸载
   */
  removeToUnitLoadDevice(usages) {
    const unitLoadDevice = this.view.selectedUnitLoadDevice
    unitLoadDevice.isDirty = true
    this.manager.multiUnloadUnitLoadDevice(usages)
    this.refreshSalves()
    this.refreshUsages()

    // 记录 装箱(移除装箱会改变 removedUnitLoadDeviceUsages 中的值) 同cargo中的syncActionItems
    this.syncActionItems()
  }

  /**
   * 返回需要同步保存的对象列表
   */
  syncActionItems() {
    this.job.delUnitLoadDeviceUsageUuids = []
    for (const item of this.manager.removedUnitLoadDeviceUsages) {
      this.job.delUnitLoadDeviceUsageUuids.push(item.entity.uuid)
    }
  }
  /**
   * 验证
   */
  validateForm() {
    if (this.manager) {
      const msg = this.manager.validateSlavesUsage()
      if (msg.length > 0) {
        throw new TabError(msg, 'tabLclUnitLoadDevice')
      }
    }
    return true
  }
}
